import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { authActions, centerInstructorsActions } from "../../../redux/actions";
import {
  getCurrentUserRole,
  getLocalStorageItem,
  getSessionStorageItem,
  getUserPayload,
} from "../../../system";
import {
  Directions,
  emptyString,
  roles,
  StorageKeys,
} from "../../../constants";
import { Button } from "react-bootstrap";
import { translationConstants } from "../../../constants";
import cancelIcon from "../../../assets/images/icon/cancelIcon.svg";
import tickIcon from "../../../assets/images/icon/tickIcon.svg";

const BecomeCenterInstructor = (props) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const userData = getUserPayload();
  const role = getCurrentUserRole();
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const getCenterName = () => {
    const invitedCenter = getLocalStorageItem(
      StorageKeys.instructorInvitedCenterName
    );

    if (!invitedCenter) {
      return emptyString;
    }

    if (direction === Directions.rtl) {
      return invitedCenter.arabicName || invitedCenter.name;
    } else {
      return invitedCenter.name || invitedCenter.name;
    }
  };

  const handleApprovalRejection = (isApproved) => {
    dispatch(
      centerInstructorsActions.approveRejectCenterInstructorRequest(
        isApproved,
        userData.user?.id,
        () => {
          dispatch(
            authActions.getNewUserPayload(() => {
              window.location.reload();
            })
          );
        }
      )
    );
  };

  return (
    <>
      {(role === roles.Instructor || role === roles.FreelanceInstructor) &&
        getLocalStorageItem(StorageKeys.instructorInvitedCenterName) && (
          <>
            <div className="d-none d-md-block">
              {/* Show only on large screens */}
              <div className="topBanner p-r-50 p-l-50 d-flex justify-content-between top-banner-height">
                <div className="d-flex align-items-center my-2 col-12 col-md-8 col-lg-9 col-xl-7">
                  <div className="d-flex align-items-center">
                    <p>
                      {`${t(
                        translationConstants.YOU_HAVE_BEEN_INVITED_BY
                      )} ${getCenterName()} .`}
                    </p>
                  </div>

                  <div className="d-flex">
                    <Button
                      className="approve-button mx-1 my-20 h-30"
                      type="button"
                      onClick={() => handleApprovalRejection(true)}
                    >
                      <img
                        src={tickIcon}
                        alt=""
                        className="pe-1"
                        name="approved"
                        height={18}
                      />
                      {t(translationConstants.Approve)}
                    </Button>
                    <button
                      className="reject-button mx-1 my-20 h-30"
                      type="button"
                      onClick={() => handleApprovalRejection(false)}
                    >
                      <img
                        src={cancelIcon}
                        name="rejected"
                        height={18}
                        alt=""
                        className="pe-1"
                      />
                      {t(translationConstants.Reject)}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-md-none">
              {/* Show only on medium and small screens */}
              <div className="topBanner p-r-50 p-l-50 justify-content-end">
                <div className="my-2 col-12">
                  <div className="d-flex">
                    <p>
                      {`${t(
                        translationConstants.YOU_HAVE_BEEN_INVITED_BY
                      )} ${getCenterName()} .`}
                    </p>
                  </div>

                  <div className="d-flex">
                    <Button
                      className="approve-button mx-1 my-20 h-30"
                      type="button"
                      onClick={() => handleApprovalRejection(true)}
                    >
                      <img
                        src={tickIcon}
                        alt=""
                        className="pe-1"
                        name="approved"
                        height={18}
                      />
                      {t(translationConstants.Approve)}
                    </Button>
                    <button
                      className="reject-button mx-1 my-20 h-30"
                      type="button"
                      onClick={() => handleApprovalRejection(false)}
                    >
                      <img
                        src={cancelIcon}
                        name="rejected"
                        height={18}
                        alt=""
                        className="pe-1"
                      />
                      {t(translationConstants.Reject)}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
    </>
  );
};

export default BecomeCenterInstructor;
